// LayoutModeFab.jsx

import React from "react";
import { Fab, Tooltip } from "@mui/material";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import DonutSmallIcon from "@mui/icons-material/DonutSmall";
import { marginFab, separationFab, zIndexBotones } from "./helpers";

const LayoutModeFab = ({ layoutMode, onToggle, fabNumber = 0 }) => {
    const isGroups = layoutMode === "groups";

    return (
        <Tooltip
            title={
                isGroups ? "Ver nodos en cuadrícula" : "Ver nodos por grupos"
            }
        >
            <Fab
                color="primary"
                onClick={onToggle}
                sx={{
                    position: "fixed",
                    top: marginFab + separationFab * fabNumber,
                    left: marginFab,
                    zIndex: zIndexBotones,
                }}
                aria-label="toggle-layout"
            >
                {isGroups ? <ViewModuleIcon /> : <DonutSmallIcon />}
            </Fab>
        </Tooltip>
    );
};

export default LayoutModeFab;
